import { withCompInfo } from '@wix/editor-elements-integrations'
import type { LanguageSelectorDefinition, LanguageSelectorCSSVars } from './LanguageSelector'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getHeightCSS } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<LanguageSelectorCSSVars, LanguageSelectorDefinition>()(
	[
		'compProps',
		'compLayout',
		'compSingleLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'compId',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, compLayout, compSingleLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const heightCSS = getHeightCSS(compLayout, compSingleLayout)
		return {
			'--itemFont': getScaledFont(compInfo, 'itemFont', isOneDocMigrated),
			'--height': heightCSS,
			'--iconSize': `${compProps.iconSize || styleProperties.iconSize}px`,
		}
	}
)
